const faqs = [
  {
    q: '榴莲视频与97视频、丝瓜视频是什么关系？',
    a: '榴莲视频是一个独立的在线视频平台对比导航站点，与97视频、丝瓜视频、蓝莓视频、91在线视频、糖心视频、黑桃视频等平台均为独立运营主体。我们仅提供平台信息对比和导航服务，帮助用户更好地了解各平台特色。',
  },
  {
    q: '如何在多个在线视频平台之间做选择？',
    a: '建议从以下几个维度综合考量：内容偏好（各平台内容侧重不同）、使用频率（高频用户建议选择会员性价比较高的平台）、访问稳定性（不同地区访问体验可能不同）、以及费用预算。本站各专题会持续更新对比信息供参考。',
  },
  {
    q: '站内推荐的所有在线视频平台都安全吗？',
    a: '我们收录的平台均为市场上有一定用户基础的成熟平台。但请务必注意：在线影视平台的运营状态可能随时变化，建议用户自行核实当前状态，本站导航信息仅供参考，不构成任何推荐或担保。',
  },
  {
    q: '如何第一时间获取各平台的最新动态？',
    a: '本站"最新动态"模块持续追踪97视频、丝瓜视频、蓝莓视频等平台的更新信息，另外你也可以关注各平台的官方渠道。我们会及时汇总重要更新和变化，帮你不错过关键信息。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4 whitespace-nowrap">
            常见问答
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            常见问题解答
          </h2>
          <p className="mt-3 text-foreground-600 text-sm max-w-xl mx-auto">
            关于在线视频平台对比导航的常见疑问
          </p>
        </div>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-100 rounded-xl border border-background-200/60">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm font-semibold text-foreground-900 pr-4 font-heading">
                  {faq.q}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 group-open:bg-primary-100 transition-colors">
                  <i className="ri-add-line text-sm text-foreground-500 group-open:hidden"></i>
                  <i className="ri-subtract-line text-sm text-primary-600 hidden group-open:block"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}